import styled from "styled-components";
import SVG from "react-inlinesvg";

export const Container = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    position: relative;
    border-radius: 7.17px;
    border: ${props => '2px solid'+props.$borderColor};
    background: #FFF;
    height: 270.6666px;
    max-width: 330px;
`;


export const FileInput = styled.input`
    position: absolute;
    overflow: hidden;
    bottom: 15px;
    right: 15px;
    width: 24px;
    height: 24px;
    z-index: 99;
    opacity: 0;
    cursor: pointer;
    &::file-selector-button{
        cursor: pointer;
    }
`;

export const UploadButton = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
`;

export const PreviewImage = styled.img`
    max-width: 100%;
    max-height: 100%;
    border-radius: 15px;
`;

export const ExcluirIcon = styled(SVG)`
    position: absolute;
    bottom: 15px;
    left: 15px;
    width: 24px;
    height: 24px;
    cursor: pointer;
`;

export const ImageIcons = styled(SVG)`
    position: absolute;
    bottom: 15px;
    right: 15px;
    width: 24px;
    height: 24px;
    cursor: pointer;
    & path {
        fill: ${({ color }) => color};
    }
`;